 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"c09fd97e7c796d538ff159a770361b5c1b3a69c9","3":"637f5ebf782ce184e266953cfe6e3f35f9f6b0aa","4":"bd5de594aa742f31ad8d0030a6219308665a3f1e","5":"29107295","6":"2c6113cbda37d29ef22686c16987e21180bac5f8","7":"40a30220d433427f9c7c409e877ccd29bb9657b5","8":"5e546ea4487864958d1f528a920cbb5efaec4717","9":"98a6d3ec35463c6a5c4845e868b9232e35ac3b9a","10":"cb1608f2","11":"f3f7b0a9489c5f25bf88b1aff650332a0399af4f","12":"c7f8c3e4","13":"01ffa089f6d5fed11d9286de39a2f26f8e6d84fe","14":"d5e7336c00f89b69e6fd3e9e6b4d490491272d50","16":"0b7b90cd","18":"component---cache-sckit-redirect-js","19":"component---src-pages-404-js","20":"component---src-pages-codex-js","21":"component---src-pages-contact-js","22":"component---src-pages-creator-js","23":"component---src-pages-database-divisions-js","24":"component---src-pages-database-faction-js","25":"component---src-pages-database-heroes-js","26":"component---src-pages-database-index-js","27":"component---src-pages-database-infantry-js","28":"component---src-pages-database-others-js","29":"component---src-pages-database-sa-js","30":"component---src-pages-index-js","31":"component---src-pages-map-divisions-js","32":"component---src-pages-map-europe-js","33":"component---src-pages-map-events-js","34":"component---src-pages-map-factions-js","35":"component---src-pages-map-index-js","36":"component---src-pages-map-places-js","37":"component---src-pages-news-js","38":"component---src-pages-policy-js","39":"component---src-pages-products-js","40":"component---src-pages-search-js","41":"component---src-pages-setting-js","42":"component---src-pages-terms-js","43":"component---src-templates-codex-post-js","44":"component---src-templates-division-post-js","45":"component---src-templates-event-post-js","46":"component---src-templates-faction-post-js","47":"component---src-templates-news-post-js","48":"component---src-templates-place-post-js","49":"component---src-templates-product-post-js","50":"component---src-templates-unit-post-js"}[chunkId]||chunkId) + "-" + {"0":"399502027b249666cbdc","1":"9634fa09485d6a8d4ff4","2":"b8b4d27e66475e5429c0","3":"8f8c9dbd22b84f0574fa","4":"996d8a7466d7d6138688","5":"1bf005e33ac4aeec1be5","6":"60ab8db28df0278c82ad","7":"2f60a7714e9055cbd1da","8":"1dc21702af2063a824cc","9":"ba1681c7543ffd9a18ef","10":"282ce8dadddbcc738544","11":"521061f313fe38b2bc49","12":"393231ae89a24fe61caf","13":"dd38abb1e8c79b87a7a3","14":"7857fdcc68bd61a2b225","16":"15f400598d56c533fd55","18":"a9093c7df3a67d9ff1fb","19":"82aa28e7872832d8d97e","20":"347df7c22c467b922e2f","21":"b5b7915b864bc657dd14","22":"475b0d5b5fea11972985","23":"e51024501586d49ba14a","24":"5908a3a1a3bfe6a67ba3","25":"c58caae72bcb9942933f","26":"1da141f5403a29b340e6","27":"77e2aad6aa1ad4a13bc3","28":"80d246813ad6a865fff5","29":"a5c089a6b98f1bf1cbbe","30":"65800a603e7bb5727c80","31":"9efc89358cc51ed802d3","32":"1afd94e54df941911a1b","33":"5b7437c92bf0cda67c3f","34":"5559f5c88f663f9ae398","35":"14e792543f8aec3c1c58","36":"94e7fe712559ac14ae3d","37":"3d6823c86f716a1d0d88","38":"d19115405967b93252d2","39":"d043ca7a86c0afa392a4","40":"f476e041903e3ce4ddac","41":"d50952a116402de17081","42":"fa21d9b356baee5eb33b","43":"4fd7002de6d6b8b6eab3","44":"f676c614acbf7b6fb717","45":"477d0696b00153a14cec","46":"9a0f5281a720c1f082b0","47":"7f955af9f33ed46c3124","48":"2eaf00dcf6d4a2a2b74a","49":"f3cfef2c3006d29b803a","50":"9b6b48cd488990a7ada6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"c09fd97e7c796d538ff159a770361b5c1b3a69c9","3":"637f5ebf782ce184e266953cfe6e3f35f9f6b0aa","4":"bd5de594aa742f31ad8d0030a6219308665a3f1e","5":"29107295","6":"2c6113cbda37d29ef22686c16987e21180bac5f8","7":"40a30220d433427f9c7c409e877ccd29bb9657b5","8":"5e546ea4487864958d1f528a920cbb5efaec4717","9":"98a6d3ec35463c6a5c4845e868b9232e35ac3b9a","10":"cb1608f2","11":"f3f7b0a9489c5f25bf88b1aff650332a0399af4f","12":"c7f8c3e4","13":"01ffa089f6d5fed11d9286de39a2f26f8e6d84fe","14":"d5e7336c00f89b69e6fd3e9e6b4d490491272d50","16":"0b7b90cd","18":"component---cache-sckit-redirect-js","19":"component---src-pages-404-js","20":"component---src-pages-codex-js","21":"component---src-pages-contact-js","22":"component---src-pages-creator-js","23":"component---src-pages-database-divisions-js","24":"component---src-pages-database-faction-js","25":"component---src-pages-database-heroes-js","26":"component---src-pages-database-index-js","27":"component---src-pages-database-infantry-js","28":"component---src-pages-database-others-js","29":"component---src-pages-database-sa-js","30":"component---src-pages-index-js","31":"component---src-pages-map-divisions-js","32":"component---src-pages-map-europe-js","33":"component---src-pages-map-events-js","34":"component---src-pages-map-factions-js","35":"component---src-pages-map-index-js","36":"component---src-pages-map-places-js","37":"component---src-pages-news-js","38":"component---src-pages-policy-js","39":"component---src-pages-products-js","40":"component---src-pages-search-js","41":"component---src-pages-setting-js","42":"component---src-pages-terms-js","43":"component---src-templates-codex-post-js","44":"component---src-templates-division-post-js","45":"component---src-templates-event-post-js","46":"component---src-templates-faction-post-js","47":"component---src-templates-news-post-js","48":"component---src-templates-place-post-js","49":"component---src-templates-product-post-js","50":"component---src-templates-unit-post-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"0506b08a3d108701ac41","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
